import { Link } from "react-router-dom";
import { ReliabilityPanel } from "../components/index.js";
import { PageHeader } from "../ui/Feedback.jsx";

/**
 * The administrator's reliability screen: the same report a customer sees, with
 * no project filter.
 *
 * It is a separate screen rather than a block on the admin home because it is a
 * different kind of reading. The admin home answers "who is on the platform and
 * is anything on fire"; this answers "which calendars and which suppliers are
 * failing", and it is the screen an operator opens during an incident, when the
 * customer list is noise.
 *
 * The one thing this view has that a customer's cannot: a calendar can be watched
 * by several projects, so each row counts them. That matters when deciding
 * whether an outage is one customer's integration or a supplier's, and it is why
 * the row does not name a single owner.
 */
export default function AdminReliabilityScreen() {
  return (
    <div>
      <PageHeader
        title="Reliability"
        subtitle="Failure share across every customer's calendars, at three levels of the same measurement."
        actions={
          <Link className="ical-btn" to="/admin" style={{ textDecoration: "none" }}>
            Back to admin
          </Link>
        }
      />
      <ReliabilityPanel scope="admin" />
    </div>
  );
}
